import { z } from 'zod';

const SStandardMetaResponse = z.object({
  total_items: z.number(),
  per_page_size: z.number(),
  total_pages: z.number(),
});
const SStandardErrorResponse = z.object({
  status: z.boolean(),
  message: z.string(),
  code: z.number(),
});

export function createStandardResponse<T extends z.ZodType>(data: T) {
  return z.object({
    meta: SStandardMetaResponse.nullable(),
    error: SStandardErrorResponse,
    data,
  });
}
export type TStandardResponse = z.infer<
  ReturnType<typeof createStandardResponse<any>>
>;

const STorajaError = z.object({
  title: z.string(),
  message: z.string(),
});

export const STorajaErrorResponse = z.object({
  error: STorajaError,
});
export const STorajaErrorStringResponse = z.object({
  error: z.string(),
});
export type TTorajaErrorResponse =
  | z.infer<typeof STorajaErrorResponse>
  | z.infer<typeof STorajaErrorStringResponse>;
